import { createSlice } from '@reduxjs/toolkit';
import {ResponseApi} from "../BaseApi";

const HidSlice = createSlice({
    name: 'hid',
    initialState: {
        getHidRecordDetails: {},
        createHidRecord: {},
        createHidSioRecord: {},
        createHidInput: {},
        createFormat: {},
        createHidReader: {},
        getSio: {},
        getAllSiosByHidId: {},
        updateHidRecord: {},
        selectedSio: {},
        connectWithHid: false,
        sendInformationSetting: false,
        resetHid: false,
        getAcrZonesAvailable: [],
        getAcrReadersAvailableBySio: [],
        getAcrOutputsAvailableBySio: [],
        getInputTypeConnections:[],
        advanceSearchByFilters: {},
    },
    reducers: {
        clearGetHidRecordDetails: (state, action) => {
            state.getHidRecordDetails = {};
        },
    },
    extraReducers: {
        'hid/getHidRecordDetails/fulfilled': (state, action) => {
            state.getHidRecordDetails = ResponseApi(action.payload);
        },
        'hid/connectWithHid/fulfilled': (state, action) => {
            state.connectWithHid = ResponseApi(action.payload);
        },
        'hid/sendInformationSetting/fulfilled': (state, action) => {
            state.sendInformationSetting = ResponseApi(action.payload);
        },
        'hid/resetHid/fulfilled': (state, action) => {
            state.resetHid = ResponseApi(action.payload);
        },
        'hid/createHidRecord/fulfilled': (state, action) => {
            state.createHidRecord = ResponseApi(action.payload);
        },
        'hid/createHidSioRecord/fulfilled': (state, action) => {
            state.createHidSioRecord = ResponseApi(action.payload);
        },
        'hid/createHidInput/fulfilled': (state, action) => {
            state.createHidInput = ResponseApi(action.payload);
        },
        'hid/createFormat/fulfilled': (state, action) => {
            state.createFormat = ResponseApi(action.payload);
        },
        'hid/createHidReader/fulfilled': (state, action) => {
            state.createHidReader = ResponseApi(action.payload);
        },
        'hid/getSio/fulfilled': (state, action) => {
            state.getSio = ResponseApi(action.payload);
        },
        'hid/getAllSiosByHidId/fulfilled': (state, action) => {
            state.getAllSiosByHidId = ResponseApi(action.payload);
        },
        'hid/updateHidRecord/fulfilled': (state, action) => {
            state.updateHidRecord = ResponseApi(action.payload);
        },
        'hid/getAcrZonesAvailable/fulfilled': (state, action) => {
            state.getAcrZonesAvailable = ResponseApi(action.payload);
        },
        'hid/getAcrReadersAvailableBySio/fulfilled': (state, action) => {
            state.getAcrReadersAvailableBySio = ResponseApi(action.payload);
        },
        'hid/getAcrOutputsAvailableBySio/fulfilled': (state, action) => {
            state.getAcrOutputsAvailableBySio = ResponseApi(action.payload);
        },
        'hid/getInputTypeConnections/fulfilled': (state, action) => {
            state.getInputTypeConnections = ResponseApi(action.payload);
        },
        'hid/advanceSearchByFilters/fulfilled': (state, action) => {
            state.advanceSearchByFilters = ResponseApi(action.payload);
        },
        clearPreview: (state) => {
            state.getPreview = [];
        },
    },
});

export const { clearGetHidRecordDetails } = HidSlice.actions;

export default HidSlice.reducer;
